var $510ebbcbf8f3c784$exports = {};
$510ebbcbf8f3c784$exports = {
    "loading": `Na\u{10D}\xedtava sa...`,
    "loadingMore": `Na\u{10D}\xedtava sa viac...`
};


export {$510ebbcbf8f3c784$exports as default};
//# sourceMappingURL=sk-SK.module.js.map
